import { render, staticRenderFns } from "./UserWorkersTable.vue?vue&type=template&id=4af970a4&"
import script from "./UserWorkersTable.vue?vue&type=script&lang=ts&"
export * from "./UserWorkersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports